import dayjs from "dayjs";

export type LookupFilters = Record<string, any>;

const isEmptyLookupValue = (value: any) =>
  value === undefined || value === null || value === "";

export const buildLookupRequestParams = (
  search: string,
  filters: LookupFilters = {},
  dateRangeKeys: string[] = [],
) => {
  const params: LookupFilters = {
    searchText: search,
    ...filters,
  };

  dateRangeKeys.forEach((key) => {
    const value = params[key];
    if (!Array.isArray(value) || !value[0] || !value[1]) return;

    params.from = dayjs(value[0]).startOf("day").toISOString();
    params.to = dayjs(value[1]).endOf("day").toISOString();
    delete params[key];
  });

  Object.keys(params).forEach((key) => {
    if (isEmptyLookupValue(params[key])) {
      delete params[key];
    }
  });

  return params;
};
